module.exports = ".digital-sign-operator-procedure-end .amd-card__content p {\n  font-size: 14px;\n  margin-bottom: 20px; }\n"